import { IconChevronRight16, UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './InfrastructureCategory.css';
import { InfrastructureIcon } from '../InfrastructureIcon';

interface IInfrastructureCategoryProps {
  icon: string;
  name: string;
  count: number;

  onClick: VoidFunction;
}

export const InfrastructureCategory: React.FC<IInfrastructureCategoryProps> = ({ icon, name, count, onClick }) => {
  return (
    <div className={styles['container']} onClick={onClick}>
      <div className={styles['icon-container']}>
        <InfrastructureIcon src={icon} className={styles['icon']} />
      </div>
      <div className={styles['name']} data-name="CategoryName">
        <UIText1>{name}</UIText1>
      </div>
      <div className={styles['count']}>
        <UIText2 color="gray60_100">{count}</UIText2>
      </div>
      <div className={styles['arrow']}>
        <IconChevronRight16 color="gray60_100" />
      </div>
    </div>
  );
};
